/**
 * Big Sky Forms - Redirect to Thank You page after form submission
 */

(function() {
  'use strict';

  if (window.location.search.includes('contact_posted=true')) {
    window.location.replace('/pages/thank-you');
  }
})();
